__turbopack_context__.v({
  "className": "geist_f60f2d2c-module__jmJ3ga__className",
  "variable": "geist_f60f2d2c-module__jmJ3ga__variable",
});
